import React, { Component } from 'react'
import { TotalBalance } from '../../widgets/TotalBalance'
import Box from '@mui/material/Box'
import SavingEnvelopes from '../../widgets/SavingEnvelopes'
import Grid from '@mui/material/Grid'
import AllIncomes from '../ui-components/money-tab/AllIncomes'

export class Accounts extends Component {
  render() {
    return (
      <Box className="dashboard-wrapper" sx={{ flexGrow: 1 }}>
        <Grid maxWidth="md" mx={"auto"}>
          <Grid container rowGap={2} columnSpacing={2}>

            <Grid item md={12} xs={12} sx={{ display: "flex" }}>
              <TotalBalance max_save={this.props.max_save} openSweep={this.props.openSweep} gid={this.props.gid} setEmbedUrl={this.props.setEmbedUrl} />
            </Grid>

            <Grid item md={12} xs={12} >
              <SavingEnvelopes gid={this.props.gid} setEmbedUrl={this.props.setEmbedUrl} />
            </Grid>

          <Grid item md={12} xs={12} >
            <AllIncomes gid={this.props.gid} />
          </Grid>
        </Grid>
        </Grid>
      </Box>
    )
  }
}

export default Accounts
